export const navIndexs=[0,1,2,3]